import React, { Component } from 'react';
import TwoColumnTable from '../TwoColumnTable';
import ContentOutline from '../ContentOutline';
import TextBlock from '../TextBlock';

import sharedStyles from '../sharedStyles.scss';

const EXAM_SUMMARY = [
  {
    topic: 'Seeks Business for the Broker-Dealer from Customers and Potential Customers',
    description:
      'Contacting current and potential customers by any method. Developing promotional and advertising material, and seeking appropriate approvals to distribute them. Describing investment products and services to current and potential customers with the intent of soliciting business.',
    weight: '12 questions, 24%',
  },
  {
    topic:
      "Opens Accounts After Obtaining and Evaluating Customers' Financial Profile and Investment Objectives",
    description:
      'Informing customers of the types of accounts and providing appropriate disclosures. Obtaining and updating customer information and documentation, including required legal documents and suspicious activity. Obtaining customer investment profile information. Obtaining required supervisory approvals.',
    weight: '8 questions, 16%',
  },
  {
    topic:
      'Provides Customers with Information About Investments, Makes Recommendations, Transfers Assets, and Maintains Appropriate Records',
    description:
      'Providing customers with investment strategies, risks and rewards, and relevant market and investment research data. Reviewing customer investment profiles to determine investment recommendations. Providing required disclosures regarding investment products and their risks. Communicating with customers about their accounts and maintaining documentation.',
    weight: '25 questions, 50%',
  },
  {
    topic:
      "Obtains and Verifies Customers' Purchase and Sales Instructions; Processes, Completes and Confirms Transactions",
    description:
      'Providing current quotes, processing and confirming customer transactions including regulatory requirements, and informing customers of delivery obligations and settlement procedures. Informing the appropriate supervisor and assisting in resolution of disputes or errors.',
    weight: '5 questions, 10%',
  },
];

class FinraS6 extends Component {
  render() {
    const { currentUser, product, inflatedContent } = this.props;

    return (
      <div className={sharedStyles.layout}>
        <div className={sharedStyles.title}>
          Investment Company and Variable Contracts Products Representative Exam{' '}
          <span className={sharedStyles.shortTitle}>(FINRA Series 6)</span>
        </div>
        <div className={sharedStyles.explanation}>
          <div className={sharedStyles.blurb}>
            The Series 6 exam - the Investment Company and Variable Contracts Products
            Representative Qualification Examination (IR) - is designed to test the
            competency of an entry-level candidate to perform their job as an investment
            company and variable contracts products representative.
          </div>
          <div className={sharedStyles.facts}>
            <ul>
              <li>
                <em>Time</em> 90 minutes
              </li>
              <li>
                <em>Format</em> 50 multiple choice
              </li>
              <li>
                <em>Passing score</em> 70% (35/50)
              </li>
              <li>
                <em>Exam fee</em> $75
              </li>
              <li>
                <em>Details</em>{' '}
                <a
                  href="https://www.finra.org/registration-exams-ce/qualification-exams/series6"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  FINRA <i className="fad fa-external-link" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <TextBlock title="Overview">
          <p>
            The Series 6 exam was created to qualify candidates as Investment Company and
            Variable Contracts Products representatives. The exam seeks to measure the
            degree to which each candidate can perform the critical functions of such a
            representative, and ensure that all proper rules and regulations are followed
            in the candidate&apos;s execution of the role.
          </p>
        </TextBlock>

        <TwoColumnTable title="FINRA's exam summary" records={EXAM_SUMMARY} />

        <ContentOutline
          currentUser={currentUser}
          product={product}
          inflatedContent={inflatedContent}
        />

        <TextBlock title="Eligibility and sponsorship">
          <p>
            The Series 6 has a co-requisite for licensing with the Securities Industry
            Essentials (SIE) exam. Both exams must be completed in order to become fully
            licensed with your FINRA Series 6.
          </p>
          <p>
            You need to be sponsored by a FINRA member firm or a self-regulatory
            organization (SRO), typically your employer, in order to register for and take
            the Series 6 exam. You will also need to fill out and submit Form U4, which
            can be found on and submitted electronically on FINRA&apos;s website.
          </p>
        </TextBlock>

        <TextBlock title="Administration of the exam">
          <p>
            The Series 6 exam is administered via computer. A tutorial on how to take the
            exam is provided prior to taking the exam.
          </p>
          <p>
            Each candidate&apos;s exam includes 5 additional, unidentified pretest items
            that do not contribute toward the candidate&apos;s score. The pretest items
            are randomly distributed throughout the exam. Therefore, each candidate&apos;s
            exam consists of a total of 55 items (50 scored and 5 unscored).
          </p>
          <p>
            There is no penalty for guessing. Therefore, candidates should attempt to
            answer all items.
          </p>
          <p>Candidates will be allowed 90 minutes to complete the Series 6 exam.</p>
          <p>
            Candidates are not permitted to bring reference materials to their testing
            session. Severe penalties are imposed on candidates who cheat or attempt to
            cheat on FINRA-administered exams.
          </p>
        </TextBlock>

        <TextBlock title="Scoring of the exam">
          <p>
            All candidate test scores are placed on a common scale using a statistical
            adjustment process known as equating. Equating scores to a common scale
            accounts for the slight variations in difficulty that may exist among the
            different sets of exam items that candidates receive. This allows for a fair
            comparison of scores and ensures that every candidate is held to the same
            passing standard regardless of which set of exam items they received.
          </p>
        </TextBlock>
      </div>
    );
  }
}

export default FinraS6;
